/* eslint-disable promise/no-nesting */
/* global freeGiftProduct1, freeGiftProduct2, freeGiftConditions1, freeGiftConditions2 */

import $ from "jquery";
import { Engine } from "json-rules-engine";

/** Heroku utility server endpoint */
const kfUtility = "https://kf-utility.herokuapp.com";

/** Storefront access token */
const SHOPIFY_STOREFRONT_ACCESS_TOKEN = `99e8f46136310b52aabca40a26a963ab`;

/** GraphQL endpoint */
const SHOPIFY_GRAPHQL_URI = `https://kf-apps.myshopify.com/api/graphql`;

/** Products GraphQL query */
const PRODUCTS = `
  query products($numProducts: Int!, $queryString: String!, $cursor: String) {
    products(first: $numProducts, query: $queryString, after: $cursor) {
      pageInfo {
        hasNextPage        
      }
      edges {
        cursor
        node {
          id
          title        
          handle
          tags
        }
      }
    }
  }`;

  
/**
 * Shopify.init
 */
Shopify.init = async () => {
  /* Populate global variables for gift processing, et. al */
  Object.assign(Shopify, {
    entitledDiscount: false,
    needsPageReload: false,
    queue: [],
    products: [],
    freeGiftEngine1: new Engine(),
    freeGiftEngine2: new Engine(),
    giftConditions1: [],
    giftConditions2: [],
    giftFacts1: {},
    giftFacts2: {},    
    usedIds: [],
    usedCollections: [],
    cart: {},
  });

  /* Parse gift conditions #1 and #2 */
  Shopify.parseGiftConditions(
    freeGiftConditions1,
    Shopify.giftConditions1,
    Shopify.giftFacts1,
    Shopify.freeGiftEngine1
  );
  Shopify.parseGiftConditions(
    freeGiftConditions2,
    Shopify.giftConditions2,
    Shopify.giftFacts2,
    Shopify.freeGiftEngine2
  );

  /** Get array of all products w/ tags */
  await Shopify.getAllProducts()
    .then(async (response) => {
      Shopify.products = await response;      
    })
    .then(async () => {
      Shopify.flushQueue();
    })
    .catch((err) => {
      console.log("err is ", err);
    });
};


/**
 * Get first cart item which matches handle
 * @param  {String} itemHandle
 * @returns {Array} items
 */
Shopify.getCartItemByHandle = (itemHandle) => {
  return Shopify.cart.items.find(({ handle }) => handle === itemHandle);
};


/**
 * Shopify.pushToQueue
 * @param  {String} method
 * @param  {String} property
 * @param  {String} quantity
 */
Shopify.pushToQueue = async (method, property, quantity) => {
  await Shopify.queue.push({
    method,
    property,
    quantity,
  });
};


/**
 * Shopify.processQueue
 */
Shopify.processQueue = async () => {
  if (!Object.prototype.hasOwnProperty.call(Shopify.cart, "items")) {
    Object.assign(Shopify.cart, await Shopify.getCartContents());
  }
  let item = null;
  for (item of Shopify.queue) {
    // Adds item to cart
    if (item.method === "add") {
      await Shopify.addProduct(item.property, item.quantity);
      Object.assign(Shopify.cart, await Shopify.getCartContents());
    }
    // Changes item quantity
    if (item.method === "change") {
      Object.assign(
        Shopify.cart,
        await Shopify.changeProduct(item.property, item.quantity)
      );
    }
    // Removes (purges) item from cart
    if (item.method === "purge") {
      const itemId = Shopify.getCartItemByHandle(item.property).id;
      Object.assign(
        Shopify.cart,
        await Shopify.changeProduct(itemId.toString(), item.quantity.toString())
      );
    }
  }
  return Shopify.cart;
};


/**
 * Shopify.flushQueue
 **/
Shopify.flushQueue = async () => {
  
  $(".productList").html(`<li>${window.theSpinner}</li>`)

  // Process gift conditions #1
  await Promise.all([    
    Shopify.compareGiftFacts(
      Shopify.giftFacts1,
      freeGiftProduct1,
      "#giftProductList1"
    ),
    Shopify.compareGiftFacts(
      Shopify.giftFacts2,
      freeGiftProduct2,
      "#giftProductList2"
    ),
    Shopify.processQueue().then(async () => {
      Shopify.queue = [];
      await Promise.all([
        Shopify.applyFreeGifts(),
        Shopify.buildCartProductList(),
        Shopify.updateCartTotals(),
        Shopify.buildCartCTAList(),
        Shopify.applyDiscount(),
      ]);
    }),
  ]);

  // Process gift conditions #2
  await Promise.all([    
    Shopify.compareGiftFacts(
      Shopify.giftFacts1,
      freeGiftProduct1,
      "#giftProductList1"
    ),
    Shopify.compareGiftFacts(
      Shopify.giftFacts2,
      freeGiftProduct2,
      "#giftProductList2"
    ),
    Shopify.processQueue().then(async () => {
      Shopify.queue = [];
      await Promise.all([
        Shopify.applyFreeGifts(),
        Shopify.buildCartProductList(),
        Shopify.updateCartTotals(),
        Shopify.buildCartCTAList(),
        Shopify.applyDiscount(),
      ]);
    }),
  ]);

  // Update cart icon item count
  const iconCart = document.getElementById("icon-cart");

  if (iconCart) {
    if (Shopify.cart.item_count > 0) {
      iconCart.dataset.count = Shopify.cart.item_count;
    } else {
      iconCart.removeAttribute("data-count");
    }
  }

  if (Shopify.needsPageReload && window.location.pathname === "/cart") {
    location.reload();
  }
};


/**
 * Find products using query string
 *
 * @param {{ queryString: string }} { queryString }
 * @returns
 */
Shopify.getProducts = async (numProducts, queryString, cursor) => {
  const productsQuery = {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_ACCESS_TOKEN
    },
    body: JSON.stringify({
      query: PRODUCTS,
      variables: { 
        numProducts: numProducts,
        queryString: queryString,
        cursor: cursor
      }
    })
  };

  return fetch(SHOPIFY_GRAPHQL_URI, productsQuery)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      return Error(response.statusText);
    })
    .catch((error) => {
      return Error(error.message);
    });
};


Shopify.getAllProducts = async () => {
  let products = (await Shopify.getProducts(50, 'available_for_sale:true')).data.products;  
  let hasNextPage = products.pageInfo.hasNextPage;  
  let edges = products.edges;
  let cursor = edges[edges.length - 1].cursor;

  while (hasNextPage) {    
    products = (await Shopify.getProducts(50, 'available_for_sale:true', cursor)).data.products;
    hasNextPage = products.pageInfo.hasNextPage;
    cursor = products.edges[products.edges.length - 1].cursor;
    Array.prototype.push.apply(edges, products.edges);
  }

  return edges.map(edge => edge.node);
};


/**
 * Shopify.getCartContents
 */
Shopify.getCartContents = () => {
  return fetch(`/cart.js`)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      return Error(response.statusText);
    })
    .catch((error) => {
      return Error(error.message);
    });
};


/**
 * Shopify.getProduct
 * @param  {string} handle
 */
Shopify.getProduct = (handle) => {
  return fetch(`/products/${handle}.js`)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      return Error(response.statusText);
    })
    .catch((error) => {
      return Error(error.message);
    });
};

/**
 * Shopify.addProduct
 * @param  {string} id
 * @param  {string} quantity
 */
Shopify.addProduct = (id, quantity) => {
  return fetch(`/cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ id, quantity }),
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      return Error(response.statusText);
    })
    .catch((error) => {
      return Error(error.message);
    });
};

/**
 * Shopify.changeProduct
 * @param  {string} id
 * @param  {string} quantity
 */
Shopify.changeProduct = (id, quantity) => {
  return fetch(`/cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ id, quantity }),
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      return Error(response.statusText);
    })
    .catch((error) => {
      return Error(error.message);
    });
};

/**
 * An array of product handles (ie, "[ 'borderlands-3', 'rush-thumbsticks' ]")
 * @param  {Object} products
 * @returns {Array} product handles
 */
Shopify.getHandlesArray = (products) => {
  const productHandles = [];
  products.forEach((product, index) => {
    productHandles[index] = product.handle;
  });
  return productHandles;
};

/**
 * Get customer tags from local storage
 * @returns {Object}
 */
Shopify.getCustomerTags = () => {
  if (userObj && Object.prototype.hasOwnProperty.call(userObj, "userTags")) {
    if (userObj.userTags) {
      const customerTags = userObj.userTags.split(",");
      localStorage.setItem("customerTags", customerTags);
      return customerTags;
    } else {
      return [];
    }
  } else if (localStorage.getItem("customerTags")) {
    return localStorage.getItem("customerTags");
  }
};


/**
 * Get product tags by handle
 * @param  {string} productHandle
 * @returns {Array} product tags
 */
Shopify.getProductTags = (productHandle) => {
  if (Object.prototype.hasOwnProperty.call(Shopify, "products")) {
    const product = Shopify.products.find(product => product.handle === productHandle);
    if (product !== undefined) {
      return product.tags;
    }
  }
  return null;
};



/**
 * Update product quantity
 * @param  {string} method
 * @param  {string} id
 */
Shopify.updateProductQuantity = async (method, id) => {
  const el = `#${id}__id`;
  let qty = $(el).val();
  if (method === "subtract") {
    if (qty <= 0) {
      qty = 0;
    } else {
      qty--;
    }
    Shopify.pushToQueue("change", id.toString(), qty.toString());
  } else if (method === "add") {
    qty++;
    Shopify.pushToQueue("change", id.toString(), qty.toString());
  }
  $(el).val(qty);

  await Shopify.flushQueue();
};

/**
 * Parse variants
 * @param  {String} itemId
 * @param  {Object} freeGiftProduct
 * @param  {Object} giftFacts
 */
Shopify.parseVariants = (itemId, freeGiftProduct, giftFacts) => {
  if (Object.prototype.hasOwnProperty.call(freeGiftProduct, "variants")) {
    freeGiftProduct.variants.forEach((variant) => {
      if (variant.id === itemId) {
        giftFacts.hasFreeGift = true;
      }
    });
  }
};

/**
 * Reset gift facts
 * @param  {Object} giftFacts
 */
Shopify.resetGiftFacts = (giftFacts) => {
  return Object.assign(giftFacts, {
    hasFreeGift: false,
    hasFreeGiftPrecursor: false,
    customerTags: Shopify.getCustomerTags(),
  });
};

/**
 * Apply free gifts
 * @param  {Object} response
 */
Shopify.applyFreeGifts = async () => {
  Shopify.giftFacts1 = Shopify.resetGiftFacts(Shopify.giftFacts1);
  Shopify.giftFacts2 = Shopify.resetGiftFacts(Shopify.giftFacts2);

  /** If response contains items */
  if (Object.prototype.hasOwnProperty.call(Shopify.cart, "items")) {
    Shopify.giftFacts1.cart = Shopify.getHandlesArray(Shopify.cart.items);
    Shopify.giftFacts2.cart = Shopify.giftFacts1.cart;

    Shopify.giftFacts1.cartSubtotal = Shopify.cart.original_total_price;
    Shopify.giftFacts2.cartSubtotal = Shopify.cart.original_total_price;

    for (let i = 0; i < Shopify.cart.items.length; i++) {
      const item = Shopify.cart.items[i];

      Shopify.parseVariants(item.id, freeGiftProduct1, Shopify.giftFacts1);
      Shopify.parseVariants(item.id, freeGiftProduct2, Shopify.giftFacts2);

      Shopify.giftFacts1.productHandle = item.handle;
      Shopify.giftFacts2.productHandle = item.handle;

      Shopify.giftFacts1.productTags = Shopify.getProductTags(item.handle);
      Shopify.giftFacts2.productTags = Shopify.getProductTags(item.handle);

      Shopify.giftFacts1.variantTitle = item.variant_title;
      Shopify.giftFacts2.variantTitle = item.variant_title;

      await Promise.all([
        Shopify.freeGiftEngine1.run(Shopify.giftFacts1),
        Shopify.freeGiftEngine2.run(Shopify.giftFacts2),
      ]);
    }
  }
};

/**
 * Compare gift facts against conditions
 * @param  {Object} giftFacts
 * @param  {Array} freeGiftProduct
 */
Shopify.compareGiftFacts = async (
  giftFacts,
  freeGiftProduct,
  giftProductList
) => {
  if (Object.prototype.hasOwnProperty.call(Shopify.cart, "items")) {
    /** If free gift is in cart & precursor is added  */
    if (
      (giftFacts.hasFreeGift && giftFacts.hasFreeGiftPrecursor) ||
      !giftFacts.hasFreeGift & !giftFacts.hasFreeGiftPrecursor
    ) {
      $(giftProductList).html("");
    }

    /** If free gift is in cart & precursor is removed */
    if (
      giftFacts.hasFreeGift & !giftFacts.hasFreeGiftPrecursor ||
      (giftFacts.hasFreeGift && Shopify.cart.items.length === 1)
    ) {
      // Shopify.pushToQueue('change', freeGiftProduct.variants[0].id, '0');
      Shopify.pushToQueue("purge", freeGiftProduct.handle, "0");
      // Fix for legacy cart page
      Shopify.needsPageReload = true;
      $(giftProductList).html("");
    }

    /** If free gift is not in cart & precursor is added */
    if (!giftFacts.hasFreeGift && giftFacts.hasFreeGiftPrecursor) {
      /** Handle gifts automatically for products with one variant */
      if (
        Object.prototype.hasOwnProperty.call(freeGiftProduct, "variants") &&
        freeGiftProduct.variants.length === 1
      ) {
        Shopify.pushToQueue(
          "add",
          freeGiftProduct.variants[0].id.toString(),
          "1"
        );
      } else {
        /** Generate product HTML for gifts w/ multiple variants */
        const giftMarkup = await Shopify.getProduct(
          freeGiftProduct.handle
        ).then((response) => {
          return Shopify.buildProductMarkup(response);
        });
        $(giftProductList).html(giftMarkup);
      }
    }
  }
};

/**
 * Build cart product list
 * @param  {Object} resp
 */
Shopify.buildCartProductList = () => {
  if (Object.prototype.hasOwnProperty.call(Shopify.cart, "items")) {
    let theMarkup = ``;
    for (let i = 0; i < Shopify.cart.items.length; i++) {
      theMarkup += Shopify.buildProductListMarkup(Shopify.cart.items[i], i + 1);
    }
    $(".productList").html(theMarkup);
  } else {    
    $(".productList").html(
      `<li>Nothing yet, continue <a href="/collections/thumbsticks">shopping</a></li>`
    );
  }
};

/**
 * Serialize form target
 * @param  {Object} target
 */
Shopify.serialize = (target) => {
  const result = {};
  const serialized = $(target).serialize();
  `?${serialized}`
    .slice(1)
    .split("&")
    .forEach((pair) => {
      const pairs = pair.split("=");
      result[pairs[0]] = decodeURIComponent(pairs[1] || "");
    });
  return JSON.parse(JSON.stringify(result));
};

/**
 * Build cart shipping meter
 * @param  {Object} cart
 */
Shopify.buildCartShippingMeter = function() {  
  
  const shippingPercentage = Math.floor(
    (Shopify.cartTotal / Shopify.cartShippingThreshold) * 100
  );
  let theMarkup = ``;

  if (Shopify.cartMoneyNeeded > 0) {
    theMarkup += `
      <div class="meterWrap">
        <span class="meterLevel" style="width:${shippingPercentage}%;"></span>
      </div>
      <p>
        <strong>
          Almost there! Spend 
          <span class="neededAmount money">${window.currencySymbol}${(Shopify.cartMoneyNeeded).toFixed(2)}</span> 
          more to get free shipping!<br><br>
          Fill your cart <a href= "/collections/thumbsticks">here</a>.
        </strong>
      </p>`;
  } else {
    theMarkup += `<p>Free shipping activated!</p>`;
  }

  return theMarkup;
};

Shopify.cartHasItems = () => {
  return !!(
    Object.prototype.hasOwnProperty.call(Shopify.cart, "items") &&
    (Array.isArray(Shopify.cart.items) && Shopify.cart.items.length)
  );
};

/**
 * buildCartProds
 * @param  {Object} cart cart object
 * @param  {String} listClass list class name
 */
Shopify.buildCartProds = async () => {
  
  $(".reco-prod-header").hide();
  $(`.reco-prod-slot-one`).html("");
  $(`.reco-prod-slot-two`).html("");
  
  Shopify.usedCollections = [];  
  Shopify.usedIds = [];  
  Shopify.cartHasCollections = [];
  Shopify.cartHasIds = [];
  Shopify.recoSlots = [];

  // If cart has items
  if (Shopify.cartHasItems()) {

    // Loop through cart items
    Shopify.cart.items.forEach((item) => {

      // Set product type handle (ie, "thumbsticks")
      const productType = Shopify.handleize(item.product_type);

      let excludeCollections = false;

      Shopify.cartRecoExcludeSkus.forEach(sku => {
        if (item.sku.includes(sku)) { excludeCollections = true }
      });
            
      if (!excludeCollections) {
        // Does the cart contain a product with a collection trigger?
        Shopify.cartHasCollections.findIndex(x => x == productType) < 0 ? Shopify.cartHasCollections.push(productType) : 0;
      }
      // Does the cart contain a product with an ID trigger?
      Shopify.cartHasIds.findIndex(x => x == item.id) < 0 ? Shopify.cartHasIds.push(item.id) : 0;
    });
    
    // Loop through reco products 
    await Shopify.cartRecoProds.map(async (reco) => {

      // Check if cart already has reco product
      const cartHasRecoProduct = Shopify.cart.items.map(item => item.handle).includes(reco.product);
        
      // If matching collections are found
      if (Shopify.cartHasCollections) {        
        await Shopify.cartHasCollections.map(async (collection) => {
          
          // Does this collection trigger a reco?
          if (collection == reco.trigger 
            &! cartHasRecoProduct 
            &! Shopify.usedCollections.includes(collection))
          {
            await Shopify.getProduct(reco.product).then(async (response) => {
              if (response.available) {
                const responseHtml = Shopify.buildProductMarkup(response);

                if (!Shopify.recoSlots.filter((elements) => elements === responseHtml).length) {
                  Shopify.recoSlots.push(responseHtml);
                }

                $(".reco-prod-header").show();
                $(`.reco-prod-slot-one`).html(Shopify.recoSlots[0]);
                $(`.reco-prod-slot-two`).html(Shopify.recoSlots[1]);
              }
            });

            Shopify.usedCollections.findIndex(x => x == collection) < 0 ? Shopify.usedCollections.push(collection) : 0;
          }
        });
      }

      // If matching ids are found
      if (Shopify.cartHasIds) {       
        await Shopify.cartHasIds.map(async (id) => {          

          // Does this id trigger a reco?
          if (id == reco.trigger
            &! cartHasRecoProduct
            &! Shopify.usedIds.includes(id))
          {
            await Shopify.getProduct(reco.product).then(async (response) => {
              if (response.available) {
                const responseHtml = Shopify.buildProductMarkup(response);

                if (!Shopify.recoSlots.filter((elements) => elements === responseHtml).length) {
                  Shopify.recoSlots.push(responseHtml);
                }

                $(".reco-prod-header").show();
                $(`.reco-prod-slot-one`).html(Shopify.recoSlots[0]);
                $(`.reco-prod-slot-two`).html(Shopify.recoSlots[1]);
              }                
            });
            
            Shopify.usedIds.findIndex(x => x == id) < 0 ? Shopify.usedIds.push(id) : 0;
          }
        });
      }
    });
  }
};

/**
 * Parse gift conditions
 * @param  {Array} freeGiftConditions an array of conditions from customizer settings
 * @param  {Array} giftConditions an array of json-rules-engine formatted conditions
 * @param  {Object} giftFacts mutable facts about the shopping cart
 * @param  {Object} freeGiftEngine json-rules-engine object
 */
Shopify.parseGiftConditions = (
  freeGiftConditions,
  giftConditions,
  giftFacts,
  freeGiftEngine
) => {
  Object(giftFacts, {
    cart: [],
    productTags: [],
    customerTags: [],
    cartSubtotal: 0,
    hasFreeGift: false,
    hasFreeGiftPrecursor: false,
    productHandle: "",
    variantTitle: "",
  });

  freeGiftConditions.forEach((condition) => {
    switch (condition.type) {
      case "product_tag":
        giftConditions.push({
          fact: "productTags",
          operator: "contains",
          value: condition.value,
        });
        break;
      case "product_handle":
        giftConditions.push({
          fact: "productHandle",
          operator: "equal",
          value: condition.value,
        });
        break;
      case "cart_subtotal":
        giftConditions.push({
          fact: "cartSubtotal",
          operator: "greaterThan",
          value: condition.value,
        });
        break;
      case "customer_tag":
        giftConditions.push({
          fact: "customerTags",
          operator: "contains",
          value: condition.value,
        });
        break;
    }
  });

  /* If gift conditions exist */
  if (giftConditions[0]) {
    freeGiftEngine.addRule({
      conditions: {
        any: [
          {
            all: giftConditions,
          },
        ],
      },
      event: {
        type: "hasFreeGiftPrecursor",
        params: {
          message: "Eligible for free gift",
        },
      },
    });

    /**
     * If eligible for free gift
     * @param  {Event} 'hasFreeGiftPrecursor'
     * @param  {} Callback
     */
    freeGiftEngine.on("hasFreeGiftPrecursor", () => {
      giftFacts.hasFreeGiftPrecursor = true;
    });
  }
};

/**
 * Calculate discount
 * @param  {Object} discount  Discount object
 * @return {Integer}          Discount amount
 */
Shopify.calcDiscount = (discount) => {
  const discountValue = parseFloat(discount.value);
  let discountAmt = 0.0;
  let dateEnd = null;

  /* Discount start date */
  const dateStart = new Date(discount.starts_at);
  const dateToday = new Date();

  /* If end date is unspecified then set far in the future */
  if (discount.ends_at) {
    dateEnd = new Date(discount.ends_at);
  } else {
    dateEnd = new Date("2100");
  }

  /* Return if discount doesn't meet date criteria */
  if (dateToday < dateStart || dateToday > dateEnd) {
    return false;
  }

  /* Return if discount has exceeded its usage limit */
  if (discount.usage_limit && discount.usage_count >= discount.usage_limit) {
    return false;
  }

  /* Ignore discounts which apply to shipping lines */
  if (discount.target_type === "shipping_line") {
    return false;
  }

  Shopify.entitledDiscount = false;

  if (discount.target_selection === "entitled") {
    Shopify.entitledDiscount = true;
    return 0;
  }

  /* Calculate percentage or fixed_amount discount */
  if (discount.value_type === "percentage") {
    discountAmt =
      ((discountValue / 100) * Shopify.cart.original_total_price) / 100;
  } else if (discount.value_type === "fixed_amount") {
    discountAmt = discountValue;
  }

  return discountAmt.toFixed(2);
};

/**
 * Apply cart discount
 * @return {Boolean}
 */
Shopify.applyDiscount = () => {
  let discountTotal = 0.0;
  let grandTotal = (Shopify.cartTotal).toFixed(2);

  if (document.getElementById("sc_tags_list") !== null) {
    document.getElementById("sc_tags_list").innerHTML = "";
  }

  /* Grab any previously applied discounts from local storage */
  const discount = JSON.parse(localStorage.getItem("sc_discount_data"));

  if (discount) {
    /* Check if discount has already been added */
    discountTotal = -Shopify.calcDiscount(discount);

    if (Shopify.entitledDiscount) {
      $("#sc_tags_list").append(`
      <div class="tag" id="${discount.id}">
        <i class="fas fa-tag"></i>
        <span id="sc_discount_name" class="tag__text">${discount.title}</span>
          <a id="sc_discount_remove" class="tag__button" onclick="Shopify.removeDiscount()">
          <i class="fas fa-times"></i>
        </a>
      </div>`);
      $(".lineItemDiscount").show();
      $("#sc_total_container").hide();
      $("#sc_discount_container").hide();
      $("#checkoutPath").attr("href", `/checkout?discount=${discount.title}`);
    } else {
      $("#sc_tags_list").append(`
        <div class="tag" id="${discount.id}">
          <i class="fas fa-tag"></i>
          <span id="sc_discount_name" class="tag__text">${discount.title}</span>
            <a id="sc_discount_remove" class="tag__button" onclick="Shopify.removeDiscount()">
            <i class="fas fa-times"></i>
          </a>
        </div>`);

      grandTotal = (Shopify.cartTotal - discountTotal).toFixed(2);
      if (grandTotal <= 0) {
        grandTotal = 0.0;
      }
      $("#sc_total_container").show();
      $("#sc_discount_container").show();
      $("#sc_discount_amount").html(
        `-${window.currencySymbol}${discountTotal.toFixed(2)}`
      );
      $("#total").text(`${window.currencySymbol}${grandTotal}`);
      $("#checkoutPath").attr("href", `/checkout?discount=${discount.title}`);
      $(".lineItemDiscount").hide();
    }
  } else {
    $("#sc_total_container").hide();
    $("#sc_discount_container").hide();
    $(".lineItemDiscount").hide();
    $("#checkoutPath").attr("href", `/checkout`);
  }
};

/**
 * Fetch discount code from kf-utility (UK)
 * @param  {String} code
 * @return {Object}
 */
Shopify.fetchDiscount = (code) => {
  return fetch(`${kfUtility}/get-discount?code=${code}`, { method: "GET" })
    .then((res) => {
      return res.json();
    })
    .catch((err) => {
      console.log("err is ", err);
    });
};

/**
 * Set discount code in local storage
 * @param {Object} res response object
 * @param {String} code discount code
 */
Shopify.setDiscount = (res, code) => {
  return res
    .then((data) => {
      if (!data) {
        $("#sc_discount_input").addClass("discountInvalid");
        $(".discountMessage").css("visibility", "visible");
        return false;
      }
      $("#sc_discount_input").removeClass("discountInvalid");
      $(".discountMessage").css("visibility", "hidden");
      data.title = code;
      localStorage.setItem("sc_discount_data", JSON.stringify(data));
      return true;
    })
    .catch((err) => {
      console.log("err is ", err);
    });
};

/**
 * Remove cart discount
 */
Shopify.removeDiscount = function() {
  localStorage.setItem("sc_discount_data", null);
  Shopify.applyDiscount();
};

/**
 * Builds variant markup from product object
 * @param  {Object} product
 * @returns {String}
 */
Shopify.buildVariantMarkup = (product) => {
  let variantMarkup = ``;

  if (
    Object.prototype.hasOwnProperty.call(product, "variants") &&
    product.variants.length > 1
  ) {
    const productVariants = JSON.stringify(product.variants);

    product.options.forEach((option, index) => {
      variantMarkup += `<div data-option-index="${index}" class="selector-wrapper js swatch">`;

      option.values.forEach((value, i) => {
        const variantValue = Shopify.handleize(value);
        const variantClass = `${product.id}_SingleOptionSelector-${i}-${variantValue}`;
        const optionName = Shopify.handleize(option.name);

        let isChecked = "";
        let variantInner = "";
        let variantInput = `
          <label class="swatch-label" for="${variantClass}">
            <span>${value}</span>
          </label>`;

        if (optionName === "color") {
          const variantStyles = `
            background-color:${variantValue};
            border-radius:50%;
            height:50px;
            width:50px;
            min-width:50px;
            background-size:contain;`;
          variantInner = `<div class="tooltip">${value}</div>`;
          variantInput = `
            <label class="hvr-outline-out" for="${variantClass}" style="${variantStyles}">                
              <span class="visually-hidden">${value}</span>
            </label>`;
        }
        if (i === 0) {
          isChecked = "checked";
        }
        const onClick = `
          window.updateVariant("${value}", ${i}, ${productVariants}, ${product.id})`;
        variantMarkup += `        
          <div class="optionWrapper" onclick='${onClick}'>
            ${variantInner}
            <input type="radio" name="SingleOptionSelector-${index}" class="swatch-element" 
              value="${variantValue}"  id="${variantClass}" 
              data-swatch-id="${product.variants[i].id}"
              data-single-option-selector 
              data-index="option${option.position}"
              data-full-value="${value}" ${isChecked}>
            ${variantInput}
          </div>`;
      });

      variantMarkup += `</div>`;
    });
  }

  variantMarkup += `<select name="id" class="no-js" data-product-select>`;

  product.variants.forEach((variant, i) => {
    const isSelected = i === 0 ? "selected" : "";
    const isAvailable = variant.available ? "" : " disabled=disabled";
    variantMarkup += `
      <option ${isSelected} ${isAvailable} value="${variant.id}">
        ${variant.title}
      </option>`;
  });

  variantMarkup += `</select>`;

  return variantMarkup;
};

/**
 * Build product markup
 * @param  {Object} product
 */
Shopify.buildProductMarkup = function(product) {
  let compareMarkup = ``;
  let priceWrapper = ``;

  if (product.compare_at_price > product.price) {
    const compareAtPrice = (product.compare_at_price/100).toFixed(2);
    compareMarkup = `<span class="visually-hidden" data-compare-text>${compareAtPrice}</span>`;
    compareMarkup += `<s data-compare-price>${compareAtPrice}</s>`;
  }

  if (product.price === 0) {
    priceWrapper = `
    <div data-price-wrapper>
      <span>Free Gift!</span>
    </div>`;
  } else {
    priceWrapper = `
      <div data-price-wrapper>
        <span data-product-price>
          <span class="currency">${window.currencySymbol}</span>
          ${product.price / 100}
        </span>
        ${compareMarkup}
      </div>`;
  }

  const theMarkup = `
    <li id="product_${product.id}">      
      <form id="${product.id}" action="/cart/add" method="post" class="d-flex align-content-center flex-wrap p-2">
        <div class="productImage flex-fill">
          <img src="${product.featured_image}">
        </div>
        <div class="productOptions flex-fill">
          <div class="product-name">
            <h3>${product.title}</h3>
          </div>
          <!-- Variants -->
          ${Shopify.buildVariantMarkup(product)}
          <div class="quantity">
            <label class="qtyLabel" for="Quantity">Qty:</label>
            <input type="number" id="Quantity_${product.id}" name="quantity" value="1" min="1">
          </div>
        </div>
        <div class="productListAddToCart flex-fill">
          ${priceWrapper}
          <div>
            <button type="submit" name="add" class="greenButton" data-add-to-cart>
              <span data-add-to-cart-text>Add to Cart</span>
            </button>
          </div>
        </div>        
      </form>
    </li>`;

  return theMarkup;
};

/**
 * buildCartCTAList
 */
Shopify.buildCartCTAList = () => {
  if (Shopify.cartCTAObj.length) {
    Shopify.cartCTAObj.forEach((cta) => {
      switch (cta) {
        case "shipping-meter":
          $(".cta.free-shipping").html(Shopify.buildCartShippingMeter());
          break;
        case "reco-prods":
          Shopify.buildCartProds();
          break;
        default:
          break;
      }
    });
  }
};

/**
 * updateCartTotals
 * @param  {Object} response
 */
Shopify.updateCartTotals = () => {
  Shopify.cartSubtotal = Shopify.cart.original_total_price / 100;
  Shopify.cartTotal    = Shopify.cart.total_price / 100;
  Shopify.cartMoneyNeeded = Shopify.cartShippingThreshold - Shopify.cartTotal;

  $(".sidecart footer .subtotal").text(`${window.currencySymbol}${(Shopify.cartSubtotal).toFixed(2)}`);
  $(".sidecart footer .total").text(`${window.currencySymbol}${(Shopify.cartTotal).toFixed(2)}`);
  $(".total").addClass("money");
};

/**
 * buildProductListMarkup
 * @param  {Object} product
 */
Shopify.buildProductListMarkup = (product) => {
  let theMarkup = ``;
  let variantMarkup = ``;

  product.variant_options.forEach((opt) => {
    if (opt !== "Default Title") {
      variantMarkup += `<h4 class="variant">${opt}</h4>`;
    }
  });

  if (
    product.handle === freeGiftProduct1.handle ||
    product.handle === freeGiftProduct2.handle
  ) {
    theMarkup += `
      <li id="product_${product.id}">
        <div class="gridContainer">
          <div class="image">
            <img src="${product.image}" alt="${product.product_title}" />
          </div>
          <div class="info" style="padding-bottom:35px;">
            <h3 class="productTitle">${product.product_title}</h3>
            ${variantMarkup}
          </div>
        </div>
      </li>`;
  } else {
    theMarkup += `
      <li id="product_${product.id}">
        <div class="gridContainer">
          <div class="image">
            <img src="${product.image}" alt="${product.product_title}" />
          </div>
          <div class="info">
            <h3 class="productTitle">${product.product_title}</h3>
            ${variantMarkup}
            <section class="qty">
              <span>Qty:</span>
              <button onClick="Shopify.updateProductQuantity('subtract', '${product.id}')" class="roundBtn minusBtn">
                <i class="fas fa-minus"></i>
              </button>
              <input type="text" id="${product.id}__id" value="${product.quantity}" class="qty" />
              <button onClick="Shopify.updateProductQuantity('add', '${product.id}')" class="roundBtn plusBtn">
                <i class="fas fa-plus"></i>
              </button>
            </section>
          </div>
        </div>
      </li>`;
  }

  return theMarkup;
};


/**
 * toggleCartPosition
 */
Shopify.toggleCartPosition = () => {
  $("body").toggleClass("sidecart-open");
};

/**
 * Create URL handle from product title
 * @param  {String} str
 */
Shopify.handleize = (str) => {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

/**
 * Fire it up!
 *
 * @param  {} .then(async(
 */
Shopify.init()
  .then(async () => {
    let code = null;

    /** Check if discount code is set in cookie or local storage */
    if (window.getCookie("discount_code")) {
      code = window.getCookie("discount_code").toUpperCase();
    } else if (localStorage.getItem("sc_discount_code") !== null) {
      code = localStorage.getItem("sc_discount_code");
    }

    /** If discount code set, fetch and apply */
    if (code) {
      const res = Shopify.fetchDiscount(code);
      await Shopify.setDiscount(res, code);
      await Shopify.applyDiscount();
    }

    /**
     * Add to cart trigger
     *
     * @param  {Element} 'body'
     * @param  {Event} .on('submit'
     * @param  {Action} 'form[action^="/cart/add"]'
     * @param  {Target} event
     */
    $("body").on("submit", 'form[action^="/cart/add"]', async (event) => {
      event.preventDefault();
      dataLayer.push({
        event: "Sidecart",
        eventCategory: "Sidecart",
        eventAction: "Add to Cart",
        eventLabel: "",
      });
      document.body.classList.add("sidecart-open");
      const data = Shopify.serialize(event.target);
      await Shopify.pushToQueue("add", data.id, data.quantity).then(async () => {
        Shopify.flushQueue();
      });
    });

    /** Apply discount button element */
    const discountApply = document.getElementById("sc_discount_apply");

    if (discountApply) {
      /** Apply discount click event */
      discountApply.addEventListener("click", () => {
        /** Discount code input field */
        const discountInput = document
          .getElementById("sc_discount_input")
          .value.toUpperCase();

        /** Add loading spinner to button element */
        discountApply.classList.add("loading-start");
        discountApply.disabled = true;

        /** Get discount data from API */
        const response = Shopify.fetchDiscount(discountInput);

        /** Set discount in cart if valid */
        return Shopify.setDiscount(response, discountInput).then(() => {
          Shopify.applyDiscount();
          discountApply.classList.remove("loading-start");
          discountApply.disabled = false;
        });
      });
    }
  })
  .catch((err) => {
    console.log("err is ", err);
  });
